/**
 * DubbingHeader Component
 *
 * Header section with icon, title, and description.
 */

import { memo } from 'react';
import { Globe } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

export const DubbingHeader = memo(function DubbingHeader() {
  const { t } = useTranslation();

  return (
    <div className="text-center mb-6 xs:mb-8">
      <div className="inline-flex items-center justify-center w-12 h-12 xs:w-14 xs:h-14 sm:w-16 sm:h-16 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl xs:rounded-2xl mb-3 xs:mb-4">
        <Globe className="h-6 w-6 xs:h-7 xs:w-7 sm:h-8 sm:w-8 text-white" />
      </div>
      <h2 className="text-xl xs:text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-2">
        {t('dubbing.title', { defaultValue: 'Media Dubbing' })}
      </h2>
      <p className="text-sm xs:text-base sm:text-lg text-gray-600 dark:text-gray-400 px-2">
        {t('dubbing.subtitle', {
          defaultValue: 'Translate and dub your videos or audio files into multiple languages',
        })}
      </p>
    </div>
  );
});
